import type { AccountsConfig } from '../ProductsConfig';

export const accounts: AccountsConfig = {
    /** Enables showing of AccountServicesView within SavingAccountDetailsView */
    showAccountServices: false,
    autosuggestOwnIbansOnly: false,
    accountNameMatchString:
        /^[\w áßäčćďđéěíĺľňóöőôřŕšťúůüűýžÁÄČĆĎĐÉĚÍĹĽŇÓÖŐÔŘŔŠŤÚŮÜŰÝŽ,.;:!?@&+\-*/()#]+$/.toString(),
    /** Alias cannot be longer than this value */
    accountNameLength: 35,
    accountNameMinimumLength: 0,
    sendAccountNumberWithPut: false,
    /** Enables creating of new multi-currency account */
    multicurrency: {
        enabled: false,
    },
    formatAccountNumber: false,
    preferredAccountNumberFormat: 'IBAN' as 'IBAN' | 'SBBAN' | 'DBBAN' | 'SPACEDBBAN',
    settingsDetails: {
        displayAccountRepresentatives: false,
    },
    isJuniorAliasChangeAllowed: false,
    isNativeAliasChangeAllowed: false,
    copyIBANForForeignAccount: false,
    accountDetailCopyActionAvailableForType: [],
};
